export default __webpack_public_path__ + "static/media/ProximaNova-Light.367531d5.otf";